// The moved premium gate (owner decision 2026-08-07): nutrition DETAIL values
// are Pro. Free users keep every row title but see this small tag where the
// value would be; tapping it opens the paywall. One component so every logging
// flow (barcode, photo, manual) locks identically.
import { Lock } from "lucide-react";
import { useT } from "../lib/i18n";

export function LockedField({ label, onUpgrade }: { label: string; onUpgrade: () => void }) {
  const t = useT();
  return (
    <span className="block">
      <span className="text-sm text-fg-muted uppercase tracking-wider">{label}</span>
      <button
        type="button"
        onClick={onUpgrade}
        aria-label={t("lock.pro_hint")}
        className="input mt-1 flex items-center justify-center gap-1.5 press"
      >
        <Lock size={13} className="text-fg-muted" aria-hidden="true" />
        <span className="text-sm font-semibold text-fg-muted">Pro</span>
      </button>
    </span>
  );
}

/** Inline variant for compact rows (e.g. the scan confirm card): the same
 *  meaning at tag size. */
export function ProChip({ onUpgrade }: { onUpgrade: () => void }) {
  const t = useT();
  return (
    <button
      type="button"
      onClick={onUpgrade}
      aria-label={t("lock.pro_hint")}
      className="inline-flex items-center gap-1 rounded-full bg-surface-strong px-2.5 py-1 press"
    >
      <Lock size={11} className="text-fg-muted" aria-hidden="true" />
      <span className="text-sm font-semibold text-fg-muted">Pro</span>
    </button>
  );
}
